export default __webpack_public_path__ + "static/media/filtro-activo.d64205a0.svg";